import React from "react";

// Render inline: **grassetto** -> <strong>. Tutto il resto come testo.
function renderInline(text, keyPrefix) {
  const parts = String(text).split(/\*\*(.+?)\*\*/g); // indici dispari = grassetto
  return parts.map((p, i) =>
    i % 2 === 1
      ? <strong key={`${keyPrefix}-b${i}`}>{p}</strong>
      : <React.Fragment key={`${keyPrefix}-t${i}`}>{p}</React.Fragment>
  );
}

/**
 * Renderer "markdown-lite" per le risposte dell'AI: gestisce grassetto, elenchi
 * puntati/numerati, intestazioni e righe di tabella, senză librerie esterne.
 * Su testo semplice si comporta come una sequenza di paragrafi.
 */
export default function RichText({ text, className = "", ...rest }) {
  const lines = String(text || "").split("\n");
  const blocks = [];
  let list = null; // { type: "ul" | "ol", items: [] }

  const flush = () => {
    if (!list) return;
    const Tag = list.type === "ol" ? "ol" : "ul";
    const cls = list.type === "ol" ? "list-decimal pl-5 space-y-0.5" : "list-disc pl-5 space-y-0.5";
    blocks.push(
      <Tag key={`l${blocks.length}`} className={cls}>
        {list.items.map((it, i) => <li key={i}>{renderInline(it, `li${blocks.length}-${i}`)}</li>)}
      </Tag>
    );
    list = null;
  };

  lines.forEach((raw, idx) => {
    const trimmed = raw.replace(/\t/g, " ").trim();
    // separatore tabella markdown: | --- | --- |
    if (trimmed.includes("-") && /^\|?[\s:|-]+\|?$/.test(trimmed)) return;
    if (!trimmed) { flush(); blocks.push(<div key={`sp${idx}`} className="h-1.5" />); return; }

    const h = trimmed.match(/^#{1,6}\s+(.*)$/);
    if (h) { flush(); blocks.push(<div key={`h${idx}`} className="font-medium mt-1">{renderInline(h[1], `h${idx}`)}</div>); return; }

    const b = trimmed.match(/^[-*•]\s+(.*)$/);
    if (b) { if (!list || list.type !== "ul") { flush(); list = { type: "ul", items: [] }; } list.items.push(b[1]); return; }

    const n = trimmed.match(/^\d+\.\s+(.*)$/);
    if (n) { if (!list || list.type !== "ol") { flush(); list = { type: "ol", items: [] }; } list.items.push(n[1]); return; }

    if (trimmed.startsWith("|") && trimmed.endsWith("|")) {
      flush();
      const cells = trimmed.slice(1, -1).split("|").map((c) => c.trim()).filter(Boolean);
      blocks.push(<div key={`tr${idx}`}>{renderInline(cells.join(" · "), `tr${idx}`)}</div>);
      return;
    }

    flush();
    blocks.push(<div key={`p${idx}`}>{renderInline(trimmed, `p${idx}`)}</div>);
  });
  flush();

  return <div className={className} {...rest}>{blocks}</div>;
}
